/* eslint-disable */
import React, { useMemo, useState } from 'react';

import { WTitle } from '../../components/Widget';
import { useParams } from 'react-router-dom';
import { useStore } from '../../../../store';
import Quiz from '../../components/Quiz';
import { useUpdateComponentState } from '../../../hooks';
import Section2Icon1 from '../../../../../../assets/2025/topicAI/section2-icon1.png';
import Section2Icon2 from '../../../../../../assets/2025/topicAI/section2-icon2.png';
import Section2Img1 from '../../../../../../assets/2025/topicAI/section2-img1.png';
import Section2Img2 from '../../../../../../assets/2025/topicAI/￼section2-img2.png';
import Section2Img2H5 from '../../../../../../assets/2025/topicAI/￼section2-img2-h5.png';

interface ISection0Props {
  settings: any;
}

interface GuidelineCard {
  type: 'enterprise' | 'employee';
  title: string;
  icon: string;
  img: string;
  items: string[];
}

const Section2: React.FunctionComponent<ISection0Props> = ({ settings }) => {
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[2],
    [settings?.paragraphs]
  );

  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 1024;

  const guidelineCards: GuidelineCard[] = [
    {
      type: 'enterprise',
      title: paragraphsSettings.enterpriseTitle,
      icon: Section2Icon1,
      img: Section2Img1,
      items: paragraphsSettings.enterprisePerspective,
    },
    {
      type: 'employee',
      title: paragraphsSettings.employeeTitle,
      icon: Section2Icon2,
      img: isMobile ? Section2Img2H5 : Section2Img2,
      items: paragraphsSettings.employeePerspective,
    },
  ];
  const updateComponentState = useUpdateComponentState();
  const { quiz } = paragraphsSettings;
  const { updateParagraphState } = useStore();
  const [quizState, setQuizState] = useState(false);
  const quizComplete = () => {
    setQuizState(true);
  };

  React.useEffect(() => {
    if (quizState) {
      updateComponentState(
        p_course,
        p_topic,
        ID,
        '2025-topicAI-section2-question'
      );
    }
  }, [p_course, p_topic, quizState]);

  return (
    <div className="topic-section-2">
      <WTitle title={paragraphsSettings?.title}></WTitle>
      <div className="AI-guideline-container">
        <p className="guideline-intro">{paragraphsSettings?.desc}</p>
        {guidelineCards.map((card) => (
          <div key={card.type} className={`guideline-card ${card.type}-card`}>
            <div className={`card-badge ${card.type}-badge`}>
              <img src={card.icon} alt="" className="badge-icon" />
              <span className="badge-text">{card.title}</span>
            </div>
            <div className="card-person">
              <img src={card.img} alt="" />
            </div>
            <ul className="card-list">
              {card.items.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="local-guideline-container">
        <div className="local-guideline-bubble">
          <div className="bubble-arrow"></div>
          <div className="bubble-content">
            <p
              dangerouslySetInnerHTML={{
                __html: paragraphsSettings?.bubbleContent,
              }}
            ></p>
          </div>
        </div>
      </div>
      <div id="2025-topicAI-section2-question" className="topic-quiz">
        <Quiz
          title={paragraphsSettings?.questionTitle}
          description={quiz?.description}
          question={quiz?.question}
          options={quiz?.options}
          onCompleted={quizComplete}
        />
      </div>
    </div>
  );
};

export default React.memo(Section2);
